import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtINR } from "@/lib/leadUtils";

const monthStart = () => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0,10); };
const monthEnd = () => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth()+1, 0).toISOString().slice(0,10); };

export default function TotalProfitWidget({ initialData }) {
  const [from, setFrom] = useState(monthStart());
  const [to, setTo] = useState(monthEnd());
  const [data, setData] = useState(initialData || null);
  const [loading, setLoading] = useState(false);

  const refresh = async (f, t) => {
    setLoading(true);
    try {
      const { data } = await api.get("/dashboard/total-profit", {
        params: { from: f, to: t },
      });
      setData(data);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(from, to); /* eslint-disable-next-line */ }, []);

  const apply = () => refresh(from, to);

  return (
    <div className="bg-white border border-brand-border p-6 mb-10" data-testid="total-profit-widget">
      <div className="flex items-start justify-between flex-wrap gap-3 mb-4">
        <div>
          <div className="kicker mb-1" style={{ color: "var(--brand-champagne)" }}>STUDIO TOTAL PROFIT · CEO</div>
          <p className="text-xs text-brand-muted">
            Net of all direct project costs and studio overhead for weddings dated in the range.
          </p>
        </div>
        <div className="flex items-end gap-2 flex-wrap w-full sm:w-auto">
          <label className="block flex-1 sm:flex-initial min-w-0">
            <span className="kicker block mb-1">From</span>
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)}
                   className="w-full sm:w-auto px-3 py-1.5 text-sm border border-brand-border" style={{ borderRadius: 0 }}
                   data-testid="total-profit-from" />
          </label>
          <label className="block flex-1 sm:flex-initial min-w-0">
            <span className="kicker block mb-1">To</span>
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)}
                   className="w-full sm:w-auto px-3 py-1.5 text-sm border border-brand-border" style={{ borderRadius: 0 }}
                   data-testid="total-profit-to" />
          </label>
          <button onClick={apply}
                  disabled={loading}
                  className="px-3 py-1.5 text-[11px] tracking-[0.18em] uppercase text-white shrink-0"
                  style={{ background: "var(--brand-primary)" }}
                  data-testid="total-profit-apply">
            {loading ? "…" : "Apply"}
          </button>
        </div>
      </div>

      {!data ? (
        <p className="text-sm italic text-brand-muted">Loading…</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-px bg-brand-border">
          <Mini label="Project profit" value={fmtINR(data.total_project_profit)}
                 testId="total-profit-project-profit"
                 color={data.total_project_profit >= 0 ? "var(--brand-success)" : "var(--brand-danger)"} />
          <Mini label="Overhead" value={fmtINR(data.total_overhead)}
                 testId="total-profit-overhead" color="var(--brand-danger)" />
          <Mini label="Net profit" value={fmtINR(data.net_profit)}
                 testId="total-profit-net" bold
                 color={data.net_profit >= 0 ? "var(--brand-success)" : "var(--brand-danger)"} />
          <Mini label="Projects in range" value={String(data.project_count)}
                 testId="total-profit-project-count" color="var(--brand-ink)" />
        </div>
      )}
    </div>
  );
}

function Mini({ label, value, color, bold, testId }) {
  return (
    <div className="bg-white px-4 py-4" data-testid={testId}>
      <div className="kicker mb-2">{label}</div>
      <div
        className={bold ? "font-display text-2xl" : "text-base font-medium"}
        style={{ color: color || "var(--brand-ink)" }}
      >
        {value}
      </div>
    </div>
  );
}
